import { cn } from "@/lib/utils";
import { zodiac } from "@/utils/nationwide";

export function NationwideDraw({
  result,
  roomId,
}: {
  result: number[];
  roomId: string;
}) {
  const renderRoomComponent = () => {
    const roomType = roomId[2];
    switch (roomType) {
      case "1":
        return <OneBlueBallDraw result={result} />;
      case "2":
        return <TwoBlueBallDraw result={result} />;
      case "3":
        //目前只有一個特殊.後續有其他特殊應該要加判斷 roomId
        return <LastBallZodiacDraw result={result} />;
      default:
        return <DefaultDraw result={result} />;
    }
  };
  return <div>{renderRoomComponent()}</div>;
}

//全部開獎號紅色
function DefaultDraw({ result }: { result: number[] }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {result.map((item, index) => (
        <div key={`${Symbol(index).toString()}`}>
          <p className="flex h-8 w-8 items-center justify-center rounded-full bg-destructive px-2 py-1 text-primary-foreground">
            {item}
          </p>
        </div>
      ))}
    </div>
  );
}
//最後一位開獎號藍色
function OneBlueBallDraw({ result }: { result: number[] }) {
  return (
    <div className={cn("mx-1 mt-2 mb-1 flex flex-row gap-2 ")}>
      {result.map((item, index) => (
        <div key={`${Symbol(index).toString()}`}>
          <p
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-full px-2 py-1 text-primary-foreground",
              index + 1 === result.length ? "bg-primary" : "bg-destructive",
            )}
          >
            {item}
          </p>
        </div>
      ))}
    </div>
  );
}

//最後二位開獎號藍色
function TwoBlueBallDraw({ result }: { result: number[] }) {
  return (
    <div className={cn("mx-1 mt-2 mb-1 flex flex-row gap-2")}>
      {result.map((item, index) => (
        <div key={`${Symbol(index).toString()}`}>
          <p
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-full px-2 py-1 text-primary-foreground",
              index > 4 ? "bg-primary" : "bg-destructive",
            )}
          >
            {item}
          </p>
        </div>
      ))}
    </div>
  );
}

//最後開獎號是生肖
function LastBallZodiacDraw({ result }: { result: number[] }) {
  return (
    <div className={cn("mx-1 mt-2 mb-1 flex flex-row gap-2")}>
      {result.map((item, index) => (
        <div key={`${Symbol(index).toString()}`}>
          <p
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-full bg-destructive px-2 py-1 text-primary-foreground",
              index + 1 === result.length ? "bg-primary" : "bg-destructive",
            )}
          >
            {index + 1 === result.length ? (
              <span>{zodiac[item - 1]}</span>
            ) : (
              <span>{item}</span>
            )}
          </p>
        </div>
      ))}
    </div>
  );
}
